<template>
  <span class="checkbox-container">
    <input type="checkbox" @click="handleChange" :checked="checked" />
    <span class="checkmark"></span>
  </span>
</template>

<script>
export default {
  computed: {
    checked() {
      return Object.values(this.config?.cb).indexOf(false) == -1
    }
  },
  props: {
    config: Object
  },
  methods: {
    handleChange(e) {
      this.$emit('checkBoxAllClicked', e.currentTarget.checked)
    }
  }
}
</script>
